<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import minhead from '../../../../common/minHead/index.vue';
import config from '../../../../../../configHttp';
import atmosphere from '../mxdj/atmosphere/index.vue'
import sampling from '../mxdj/sampling/index.vue'
import { mxdj_shuiyquery,mxdj_shuiyupdate } from '../../../../../api/hjbhs.js';
export default {
	name: '',
	components: {
		minhead,atmosphere,sampling
	},
	props: {
		//数据
		fuzjdata: {
			default: {
				biaosj: [
					{
						nsrmc: '',
						nsrsbh: '',
						companyNo: ''
					}
				],
				suosq: ''
			}
		},
		swrwzlList: {
			default: []
		},
		wrwlbList: {
			default: []
		},
		wrwpfljsffList: {
			default: []
		}
	},
	data: function() {
		return {
			searchlist:getdata().searchlist,
			searchdata:getdata().searchdata,
			chooseindex:0,
			TitleData: [
				{
					label: '大气水污染物计算表'
				},
				{
					label: '抽样测算计算表'
				}
			],
		};
	},
	created() {
	},
	methods: {
		changeindex(e){
			this.chooseindex=e
		},
		submitSearch(){
			this.$refs.outset.getmxdjInfo('')
		},
		forback() {
			this.$emit('forback', '');
		},
		
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
